var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dropdown-register-group-search-input"},[_c('i',{staticClass:"bx bx-search"}),_c('input',{staticClass:"search-input",attrs:{"placeholder":"Search message..."},on:{"input":_vm.handleOnChange}})])}
var staticRenderFns = []

export { render, staticRenderFns }